import HealthApi from '../api/health';
import HealthElement from '../models/health/element';
import HealthState from '../models/health/state';
import HealthContent from '../models/health/content';
import config from '../config';

const {url, timeout} = config.api.health;
const healthApi = new HealthApi(url, timeout);

const state = {
  elements: [],
  content: [],
  state: {},
};

const getters = {
  clientHealthState: state => clientId => {
    if (!state.state[clientId] || state.state[clientId].length === 0) {
      return [];
    }

    return state.state[clientId];
  },
};

const mutations = {
  HEALTH_SET_ELEMENTS: (state, payload) => {
    state.elements = payload.map(i => new HealthElement(i));
  },

  HEALTH_SET_STATE: (state, payload) => {
    state.state[payload.clientId] = payload.items.map(i => new HealthState(i));
    state.state = Object.assign({}, state.state);
  },

  HEALTH_SET_CONTENT: (state, payload) => {
    state.content = payload.map(i => {
      if (typeof i.image !== 'undefined') {
        i.image = `${url}/..${i.image.url}`;
      }

      return new HealthContent(i);
    });
  },
};

const actions = {
  HEALTH_LOAD_ELEMENTS: async (context) => {
    const data = await healthApi.getElements(context.rootState.token);

    context.commit('HEALTH_SET_ELEMENTS', data);
  },

  HEALTH_LOAD_STATE: async (context, payload) => {
    const token = context.rootState.token;
    const result = await healthApi.getState(token, payload);
    const data = { items: result, clientId: payload };

    context.commit('HEALTH_SET_STATE', data);
  },

  HEALTH_ADD_STATE: async (context, payload) => {
    const token = context.rootState.token;
    const { data } = payload;

    await healthApi.addState(token, data);

    await context.dispatch('HEALTH_LOAD_STATE', data.user);
  },

  HEALTH_LOAD_CONTENT: async (context) => {
    const data = await healthApi.getContent(context.rootState.token);

    context.commit('HEALTH_SET_CONTENT', data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
